import React from 'react';
import { Button } from '../ui/button';
import { Heart, Gift } from 'lucide-react';

const scrollToForm = () => {
  document.getElementById('booking-form')?.scrollIntoView({ behavior: 'smooth' });
};

const WeddingsParallax = () => (
  <section
    className="relative h-[500px] md:h-[600px] bg-fixed bg-center bg-cover overflow-hidden"
    style={{
      backgroundImage:
        'url(https://customer-assets.emergentagent.com/job_lokal-landing/artifacts/gir44yyn_Website%20Wedding%20Pictures%20%288%29.svg)',
      backgroundAttachment: 'fixed',
    }}
  >
    <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70" />
    <div className="relative z-10 h-full flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="text-center text-white max-w-4xl animate-fade-in-up">
        <Heart className="w-16 h-16 mx-auto mb-6 text-[#FDB913]" />
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          Create Unforgettable Memories
        </h2>
        <p className="text-lg sm:text-xl md:text-2xl mb-10 opacity-95 leading-relaxed max-w-2xl mx-auto">
          Custom-labeled wines that make your special day even more extraordinary
        </p>
        <Button
          size="lg"
          onClick={scrollToForm}
          className="bg-[#FDB913] hover:bg-[#E5A50A] text-gray-900 font-bold text-lg px-10 py-7 transform hover:scale-105 transition-all duration-300 shadow-2xl"
        >
          <Gift className="w-6 h-6 mr-2" />
          Get Your FREE Wedding Planner
        </Button>
      </div>
    </div>
  </section>
);

export default WeddingsParallax;
